// noinspection JSUnusedGlobalSymbols

import { SerializedResponse } from "./types";

export type FetchStrategy = "chrome" | "http";
const chromeFetch: typeof fetch = async (url, options) => {
  // if we are in the background context, do a regular fetch
  if (chrome.tabs) {
    return fetch(url, options);
  }

  // otherwise forward the request to the background context
  const response = (await chrome.runtime.sendMessage({
    type: "fetch",
    url,
    options,
    referringUrl: location.href,
  })) as SerializedResponse;

  return {
    ...response,
    headers: new Headers(response.headers),
    json:
      response.json !== undefined
        ? () => Promise.resolve(response.json)
        : () => Promise.reject("no json to parse"),
    clone: () => {
      throw new Error("not implemented");
    },
    body: new ReadableStream(),
    bodyUsed: false,
    arrayBuffer: () => Promise.reject("not implemented"),
    blob: () => Promise.reject("not implemented"),
    formData: () => Promise.reject("not implemented"),
    text: () => Promise.reject("not implemented"),
  };
};

const getFetchStrategy = (strategy: FetchStrategy): typeof fetch =>
  strategy === "chrome" ? chromeFetch : fetch;

export default getFetchStrategy;
